
import swal from 'sweetalert';
import {HttpNode } from "../../../axiosInstances";


const Terminos = function(id) {
  
  const terminos=document.createElement('div')
  terminos.innerHTML= "</br>Acepto las <a style='font-size:16px;color:#25476a;font-weight:bold' href='https://set-icap.com/Descargas/Autorización Tratamiento de Datos personales Set-Icap Fx.pdf'>Políticas Tratamiento de Datos personales SET-ICAP FX</a>"
+"</br></br>Acepto <a style='font-size:16px;color:#25476a;font-weight:bold' href='https://set-icap.com/terminos-y-condiciones.pdf'>Terminos y Condiciones.</a>" 
   return (
    swal({
      title: "Aceptar Terminos y Condiciones",
      content:terminos,
      closeOnClickOutside: true,
      closeOnEsc:true,
      icon: "warning",
      //button:"ACEPTAR",
      buttons: {
        cancel: {
          text: "Rechazar",
          visible: true,
          className: "swal-button--cancel",
        },
        confirm: {
          text: "Aceptar",
          className: "swal-button--confirm",
        }
      },
      dangerMode: false,
    })
    .then((willDelete) => {
      if (willDelete) {
        HttpNode.post(`/seticap/api/user/terminos`,  {id:id});
        swal("¡Aceptaste terminos y condiciones correctamente!", {
          icon: "success",
        });
      } else {
        swal("¡Debes aceptar los terminos y condiciones para continuar!");
        localStorage.clear();
        window.localStorage.clear();
        setTimeout(() => {
          window.location.reload(); // o window.location.href = '/otra-pagina'
        }, 3000);
      }
    })
  )
}

export default Terminos;